import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index.js'
import i18n from './i18n/index.js'

// Importa AeVue components e stili
import AeVue from '@aevue/components'
// Importa sempre il CSS compilato (funziona sia in dev che prod)
import '@aevue/components/dist/aevue.css'

// Importa i temi aggiuntivi (glass è già incluso in aevue.css)
import '@aevue/components/themes/glass.css'
import '@aevue/components/themes/minimal.css'
import '@aevue/components/themes/material.css'
import '@aevue/components/themes/form-glass.css'
import '@aevue/components/themes/form-minimal.css'
import '@aevue/components/themes/form-material.css'
import '@aevue/components/themes/components.css'

// Crea l'app Vue
const app = createApp(App)

// Configura AeVue components
app.use(AeVue)

// Configura Pinia (store)
const pinia = createPinia()
app.use(pinia)

// Configura i18n
app.use(i18n)

// Configura Router
app.use(router)

// Monta l'app
app.mount('#app')

console.log('Vue App inizializzata con AeVue, Router e Store!')
